import React from 'react';
import { Box, Container, Grid, Typography, Card, Paper } from '@mui/material';
import { styled } from '@mui/material/styles';
import Navbar from './Navbar';
import Footer from './Footer';
const certificates = [
  { image: require('../Assets/Certificates/Registerationcert.jpg'), title: 'cert1' },
  { image: require('../Assets/Certificates/regist2.jpg'), title: 'cert2' },
];

const CertificateCard = styled(Paper)(({ theme }) => ({
  borderRadius: '16px',
  overflow: 'hidden',
  position: 'relative',
  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.02)',
    boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
  },
}));

const ImageOverlay = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%)',
});

const CertificateComponent = () => {
  return (
    <Container>

   <Navbar />
    <Box sx={{ 
      py: 8,
      background: '#f8f9fa',
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center'
    }}>
      <Container maxWidth="lg">
        {/* Heading */}
        <Box textAlign="center" mb={6}>
          <Typography variant="h3" sx={{
            fontWeight: 700,
            color: '#2A4D69',
            mb: 2,
            fontSize: { xs: '2rem', md: '3rem' }
          }}>
            Our Certifications
          </Typography>
          <Box sx={{
            width: '60px',
            height: '4px',
            background: '#FF7F50',
            mx: 'auto',
            borderRadius: '2px'
          }} />
        </Box>

        {/* Certificates Grid */}
        <Grid container spacing={4} justifyContent="center">
          {certificates.map((cert, index) => (
            <Grid item key={index} xs={12} sm={10} md={6} lg={5}>
              <CertificateCard elevation={4}>
                {/* Image Container */}
                <Box sx={{ position: 'relative' }}>
                  <img
                    src={cert.image}
                    alt={`Certificate ${index + 1}`}
                    style={{
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover',
                      display: 'block'
                    }}
                  />
                  <ImageOverlay />
                  
                  {/* Title */}
                  <Typography variant="h5" sx={{
                    position: 'absolute',
                    bottom: 24,
                    left: 24,
                    color: 'white',
                    fontWeight: 600,
                    fontSize: { xs: '1.25rem', md: '1.5rem' },
                    zIndex: 1
                  }}>
                    {cert.title}
                  </Typography>
                </Box>
              </CertificateCard>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
    <Footer />
    </Container>
  );
};

export default CertificateComponent;